import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSoundWave20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSoundWave20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.5 17.299v-14.6a.75.75 0 1 1 1.5 0v14.6a.75.75 0 0 1-1.5 0M6.507 14V6a.75.75 0 0 1 1.5 0v8a.75.75 0 0 1-1.5 0M12.5 6v8a.75.75 0 0 0 1.5 0V6a.75.75 0 0 0-1.5 0M4.25 8.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75M17 9.25a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSoundWave20);
